import { Box, Grid, IconButton, Typography, useTheme } from '@material-ui/core';
import React, { useState } from 'react';
import { IoCloseOutline } from 'react-icons/io5';
import SizeCard from 'shared/components/SizeCard/SizeCard';
import { COLORS } from 'shared/constants/COLORS';
import {
  compositeCardStyles,
  SelectedComp,
  EightCont,
  EightContFontWeight,
  Keyframes,
} from './EditProfileMediaCompositeCard.styles';

interface Props {
  onClose: VoidFunction;
  info: Array<{
    key: string;
    value: string;
  }>;
  handleSave: (
    val: Array<{
      key: string;
      value: string;
    }>,
  ) => void;
}

const MAX_INFO_ATTRIBUTE = 8;

const EditCompCardInfo: React.FC<Props> = ({ onClose, handleSave, info }) => {
  const theme = useTheme();
  const styles = compositeCardStyles(theme);
  const [shake, setShake] = useState('');
  const [selectedAttrib, setselectedAttrib] = useState<
    Array<{
      key: string;
      value: string;
    }>
  >(info);

  const handleAdd = ({ key, value }: { value: string; key: string }) => {
    if (selectedAttrib.length < MAX_INFO_ATTRIBUTE) {
      if (selectedAttrib.some((item) => item.key === key)) {
        setShake(key);
        return setTimeout(() => {
          setShake('');
        }, 700);
      }
      setselectedAttrib([...selectedAttrib, { key, value }]);
    } else {
      setShake('eight');
      return setTimeout(() => {
        setShake('');
      }, 700);
    }
  };

  const handleRemove = (attrib: { key: string }) => {
    const newSelectedAttrib = selectedAttrib.filter(({ key }) => key !== attrib.key);
    setselectedAttrib(newSelectedAttrib);
  };

  return (
    <div style={{ height: 850 }}>
      <Grid
        container
        style={{
          width: '100%',
          height: '100%',
        }}
        spacing={2}
      >
        <IconButton onClick={onClose} style={{ position: 'absolute', right: '10px', top: '10px' }}>
          <IoCloseOutline />
        </IconButton>
        <div style={{ display: 'flex', flex: 1 }}>
          <Box sx={styles.sizeCardWrapper}>
            <SizeCard
              onSave={() => handleSave(selectedAttrib)}
              compCardAdd={(key) => handleAdd(key)}
              compCardRemove={(key) => handleRemove(key)}
            />
          </Box>
          <SelectedComp>
            <Typography variant="h6" style={{ marginBottom: '20px', textAlign: 'center' }}>
              Selected Info
            </Typography>
            <EightCont shake={shake === 'eight'}>
              <Typography style={{ marginBottom: '20px', textAlign: 'center' }}>
                You can select up to{' '}
                <EightContFontWeight isMaxValue={selectedAttrib.length === MAX_INFO_ATTRIBUTE}>
                  {selectedAttrib.length}/{MAX_INFO_ATTRIBUTE}
                </EightContFontWeight>{' '}
                attributes you want to display on your composite card
              </Typography>
            </EightCont>
            {/* map selected attrib and display as pill with COLORS.PRIMARY with minus button to remove from selectedAttrib */}
            {selectedAttrib.map((key) => (
              <Keyframes
                shake={shake === key.key} // Pass shake prop
                key={key.key}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '10px',
                  width: '100%',
                  background: COLORS.PRIMARY,
                  borderRadius: '5px',
                  padding: '10px',
                  justifyContent: 'space-between',
                  color: COLORS.WHITE,
                }}
              >
                <Typography style={{ marginRight: '10px', fontWeight: 700 }}>{key.value}</Typography>
                <IconButton
                  style={{ padding: '5px', color: COLORS.WHITE }}
                  onClick={() => {
                    setselectedAttrib(
                      selectedAttrib.filter((item) => {
                        return item.key !== key.key;
                      }),
                    );
                  }}
                >
                  <IoCloseOutline />
                </IconButton>
              </Keyframes>
            ))}
          </SelectedComp>
        </div>
      </Grid>
    </div>
  );
};

export default EditCompCardInfo;
